<bom-workspace [titleKey]="'LoggetUd.Side.Titel'">
  <h3>{{ 'LoggetUd.Side.UnderOverskrift' | tekstresource }}</h3>
  <p>{{ 'LoggetUd.Beskrivelse' | tekstresource }}</p>
  <h3>{{ 'LoggetUd.Side.VilDuFortsaette' | tekstresource }}</h3>
  <button (click)="login()" class="button button-secondary" role="button">
    {{ 'LogInd' | tekstresource }}
  </button>
</bom-workspace>
